// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Selector
import { getThemeIsDarkMode } from '../../user/account/accountModal/interface/themeSettings/themeSelector';

// Components
import iconsStyleLargeLight from './icons/large/light';
import iconsStyleLargeDark from './icons/large/dark';
import iconsStyleOutlinedLight from './icons/outlined/light';
import iconsStyleOutlinedDark from './icons/outlined/dark';

// Constants
import { FILE_TYPES_INFO } from '../../../common/files/fileConstants';

import './FileIcon.scss';

const getIconTypeThemeIndexes = (iconStyle) => {
    switch (iconStyle) {
        case 'large':
            return {
                light: iconsStyleLargeLight,
                dark: iconsStyleLargeDark,
            };
        case 'outlined':
        default:
            return {
                light: iconsStyleOutlinedLight,
                dark: iconsStyleOutlinedDark,
            };
    }
};

const mapStateToProps = (state) => ({
    isDarkMode: getThemeIsDarkMode(state),
});

const FileIcon = ({ fileType, iconName, isDarkMode, iconTheme, iconStyle = 'outlined', audioOnly }) => {
    const fileTypeDefinition = audioOnly ? FILE_TYPES_INFO.AUDIO : FILE_TYPES_INFO[fileType] || FILE_TYPES_INFO.GENERIC;
    const iconFilename = iconName || fileTypeDefinition.iconName || 'file-file';
    const theme = iconTheme || (isDarkMode ? 'dark' : 'light') || 'light';

    const themeIndex = getIconTypeThemeIndexes(iconStyle)[theme];
    const IconComponent = themeIndex[iconFilename];

    if (!IconComponent) return null;

    return (
        <div className="FileIcon">
            <IconComponent />
        </div>
    );
};

FileIcon.propTypes = {
    fileType: PropTypes.string,
    iconName: PropTypes.string,
    iconStyle: PropTypes.string,
    iconTheme: PropTypes.string,
    isDarkMode: PropTypes.bool,
    audioOnly: PropTypes.bool,
};

export default connect(mapStateToProps)(FileIcon);
